module.exports = "/img/generate-subtask.4b90f13f.png";